import { render, staticRenderFns } from "./Definition.vue?vue&type=template&id=36b5fb1e"
import script from "./Definition.vue?vue&type=script&lang=js"
export * from "./Definition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports